var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"padding":"30px"}},[_c('p',{staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v("标题："+_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }